<h2 mat-dialog-title>Mi perfil</h2>

<mat-dialog-content class="perfil-content">

  <div *ngIf="loading" class="perfil-loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">

    <!-- AVATAR -->
    <div class="perfil-avatar-row">
      <div class="perfil-avatar-wrap">
        <img *ngIf="avatarPreview || user?.photoURL"
             [src]="avatarPreview || user?.photoURL"
             class="perfil-avatar" alt="avatar" />
        <span *ngIf="!avatarPreview && !user?.photoURL" class="perfil-avatar perfil-avatar--initials">
          {{ user?.displayName?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || '?' }}
        </span>

        <!-- Botón overlay para cambiar avatar -->
        <label class="avatar-overlay" matTooltip="Cambiar avatar">
          <mat-icon>photo_camera</mat-icon>
          <input type="file" accept=".jpg,.jpeg,.png,.webp" (change)="onAvatarSelected($event)" hidden />
        </label>
      </div>

      <div class="perfil-avatar-info">
        <p class="perfil-nombre">{{ actor?.Nom }} {{ actor?.Cognom1 }} {{ actor?.Cognom2 }}</p>
        <p class="perfil-email">{{ user?.email }}</p>
        <p class="perfil-rol">{{ actor?.Rol }} · {{ actor?.raoEntidad }}</p>

        <span *ngIf="avatarFile" class="avatar-pending-hint">
          <mat-icon>info_outline</mat-icon> Se subirá al guardar
        </span>
      </div>
    </div>

    <mat-divider class="perfil-divider"></mat-divider>

    <!-- DATOS EDITABLES -->
    <form [formGroup]="form" class="perfil-form">
      <h3 class="perfil-section-title">Datos personales</h3>

      <div class="perfil-row">
        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="Nom" />
        </mat-form-field>
      </div>

      <div class="perfil-row">
        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>Primer apellido</mat-label>
          <input matInput formControlName="Cognom1" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>Segundo apellido</mat-label>
          <input matInput formControlName="Cognom2" />
        </mat-form-field>
      </div>

      <mat-divider class="perfil-divider"></mat-divider>

      <h3 class="perfil-section-title">Datos de contacto</h3>

      <div class="perfil-row">
        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>DNI / NIE</mat-label>
          <input matInput formControlName="NifNie" />
        </mat-form-field>
      </div>

      <div class="perfil-row">
        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>Teléfono</mat-label>
          <input matInput formControlName="Telefono" type="tel" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="perfil-field perfil-field--short">
          <mat-label>Ext.</mat-label>
          <input matInput formControlName="Ext" />
        </mat-form-field>
      </div>

      <div class="perfil-row">
        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>Móvil</mat-label>
          <input matInput formControlName="Mobil" type="tel" />
        </mat-form-field>
      </div>

      <div class="perfil-row">
        <mat-form-field appearance="fill" class="perfil-field">
          <mat-label>Notas</mat-label>
          <textarea matInput formControlName="Notas" rows="3" style="resize: none;"></textarea>
        </mat-form-field>
      </div>

      <mat-divider class="perfil-divider"></mat-divider>

      <!-- COMUNICACIONES -->
      <h3 class="perfil-section-title">Comunicaciones informativas</h3>
      <p class="perfil-comm-desc">
        Recibir novedades, tutoriales y actualizaciones sobre la plataforma.
        Puedes cambiar esta preferencia en cualquier momento.
      </p>

      <div class="perfil-toggle-row">
        <mat-slide-toggle formControlName="comunicaciones" color="primary">
          {{ form.value.comunicaciones ? 'Activadas' : 'Desactivadas' }}
        </mat-slide-toggle>
        <span *ngIf="consentimiento === true && fechaConsentimiento" class="perfil-consent-date">
          Aceptadas el {{ fechaConsentimiento | date:'dd/MM/yyyy' }}
        </span>
      </div>

    </form>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" [disabled]="saving || loading" (click)="save()">
    <mat-spinner *ngIf="saving" diameter="16" class="btn-spinner"></mat-spinner>
    <mat-icon *ngIf="!saving">save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>
